import { $RTKGlobalAPI } from 'shared/store'

import { apiRoutes } from 'shared/config/apiPath/apiPath'

import {
  GetCategoriesArgs,
  GetCategoriesResponse,
  GetCategoryByIdResponse,
  GetCategoryByParentResponse,
} from './types'

const query = $RTKGlobalAPI.injectEndpoints({
  endpoints: builder => ({
    getCategories: builder.query<
      GetCategoriesResponse,
      Partial<GetCategoriesArgs>
    >({
      query: ({ shuffle, ...query }) => ({
        url: apiRoutes.categoryPage.getCategories,
        params: query,
      }),
      transformResponse: (response: GetCategoriesResponse, _, query) => {
        if (query.shuffle) {
          return response.sort(() => Math.random() - 0.5)
        }
        return response
      },
    }),
    getCategoryById: builder.query<GetCategoryByIdResponse, string>({
      query: id => ({
        url: apiRoutes.categoryPage.byId(id),
      }),
    }),
    getCategoryByParent: builder.query<GetCategoryByParentResponse, void>({
      query: () => ({
        url: apiRoutes.categoryPage.byParent,
      }),
      transformResponse: (response: GetCategoryByParentResponse, _) => {
        return response.sort(() => Math.random() - 0.5)
      },
    }),
  }),
})

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useGetCategoryByParentQuery,
  endpoints: categoryEndpoints,
} = query
